export enum LiveChatPermissions {
  VIEW_LIVE_CHAT = "view_live_chat",
  CREATE_LIVE_CHAT = "create_live_chat",
  UPDATE_LIVE_CHAT = "update_live_chat",
  DELETE_LIVE_CHAT = "delete_live_chat",
  CREATE_CHAT_GROUP = "create_chat_group",
}

export const LiveChatPermissionsText: Record<LiveChatPermissions, string> = {
  [LiveChatPermissions.VIEW_LIVE_CHAT]: "View Live Chat",
  [LiveChatPermissions.CREATE_LIVE_CHAT]: "Create Live Chat",
  [LiveChatPermissions.UPDATE_LIVE_CHAT]: "Update Live Chat",
  [LiveChatPermissions.DELETE_LIVE_CHAT]: "Delete Live Chat",
  [LiveChatPermissions.CREATE_CHAT_GROUP]: "Create Chat Group",
};
